import { ConnectionRulesType } from '@/types/forms/shared/connectionRulesType';
import { Primitive } from '@/types/primitive';

export function setAllProps(obj: Record<string, unknown>, val: unknown): void {
    Object.keys(obj).forEach((k) => (obj[k] = val));
}

export function htmlDecode(input: string): string | null {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
}

/**
 * Apply template literals for static string, for example fetched from database.
 *
 * @param string static string.
 * @param context object with the content, that can be accessed from the string.
 * @returns interpolated string.
 * @example
 * ```
 * staticStringTemplateLiterals('Hello ${this.lorem}', { lorem: 'ipsum' });
 * ```
 * returns: `Hello ipsum`
 */
export function staticStringTemplateLiterals(
    string: string,
    context: unknown,
): string {
    return new Function('return `' + string + '`').call(context);
}

/**
 * Creates a new array which only contains a distinct list of the originally provided values
 * @param value The array you want to filter to only distinct values
 * @returns A new array only consisting of distinct values
 */
export function distinct(value: Primitive[]): Primitive[] {
    return Array.from(new Set(value));
}

/**
 * Checks whether the given power matches the rules
 * @param power The power to check
 * @param validRuleTypes The options that are considered valid matches
 * @returns
 */
export function powerMatchesConnectionRules(
    power: number,
    validRuleTypes: ConnectionRulesType[],
): boolean {
    return (
        (power <= 135 &&
            validRuleTypes.some(
                (value) => value === ConnectionRulesType.rules4105,
            )) ||
        (power > 135 &&
            validRuleTypes.some(
                (value) => value === ConnectionRulesType.rules4110,
            ))
    );
}

export function readableFileSize(rawFileSize: number): string {
    const bytes = rawFileSize;
    if (bytes < 0) {
        return '-';
    }
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    let i = 0;
    let value = bytes;
    while (value >= 1024 && i < units.length - 1) {
        value /= 1024;
        i++;
    }
    return `${value.toFixed(2)} ${units[i]}`;
}
